import { PAGE_LEVEL } from '@/constants';

/**
 * 舆情模块
 */
export default {
  meta: { localeModules: ['publicOpinion', 'roadshow'] },
  // 舆情
  path: '/publicOpinion',
  redirect: '/publicOpinion/index',
  children: [
    {
      path: 'index/:id?/:firstType?',
      name: 'publicOpinionIndex',
      component: () => import(/* webpackChunkName: 'public-opinion-index' */ '@/pages/publicOpinion/index.vue'),
      meta: {
        name: 'routers.public_opinion',
        parent: '/publicOpinion/index',
        componentName: 'PublicOpinionIndex',
        pageLevel: PAGE_LEVEL.FIRST,
        keepAlive: true
      }
    }
  ]
};
